
import { computed, defineComponent, onMounted, ref } from 'vue'
import Tab from '@/components/common/Tab.vue'
import List from '@/components/MyRecords/List.vue'

import { Http } from '@/plugins/axios'
import ChainTag from '@/components/ChainTag.vue'
import { connectWallet, getProvider } from '@/composables/metamask'
import AccountConnect from '@/components/accountConnect.vue'
import { getPhoneTopStyle, getTokenInfo } from '@/composables/fxwallet'
import Loading from '@/components/common/loading.vue'
import Layout from './Layout.vue'
import MyRecordList from '@/components/MyRecords/MyRecordList.vue'
import { onBeforeRouteLeave } from 'vue-router'
import { useStore } from 'vuex'

interface ITabList {
  name: string;
  value: string;
  width?: number;
}

export default defineComponent({
  name: 'MyRecords',
  components: {
    Tab,
    // List,
    ChainTag,
    AccountConnect,
    Loading,
    Layout,
    MyRecordList
  },
  setup () {
    const tabActive = ref('received') // received sent
    const tabList: ITabList[] = [
      { name: 'Received', value: 'received' },
      { name: 'Sent', value: 'sent' }
    ]

    const loading = ref(false)

    const receivedList = ref([])
    const sentList = ref([])

    const provider = getProvider()

    const redPackContractAddrInit = ref('')

    const addressInit = ref('')

    const chainIdInit = ref()

    const tokenInfoInit = ref({})

    const getRecords = () => {
      tabActive.value === 'received' ? getReceived() : getSent()
    }

    const { phoneStyle } = getPhoneTopStyle()

    const getReceived = async () => {
      const response = await Http.get<any>({
        url: '/redenvelope/v1/received',
        params: {
          chainId: chainIdInit.value,
          address: addressInit.value
        }
      })

      receivedList.value = response.envelopeList
    }

    const getSent = async () => {
      const response = await Http.get<any>({
        url: '/redenvelope/v1/sent',
        params: {
          chainId: chainIdInit.value,
          address: addressInit.value
        }
      })

      sentList.value = response.envelopeList
    }

    onMounted(async () => {
      loading.value = true

      const { redPackContractAddr, address, chainId } = await connectWallet()

      const tokenInfo = await getTokenInfo()

      addressInit.value = address
      chainIdInit.value = chainId
      redPackContractAddrInit.value = redPackContractAddr
      tokenInfoInit.value = tokenInfo

      await Promise.all([getReceived(), getSent()])

      loading.value = false
    })

    const store = useStore()

    const keepAliveInclude = computed<string[]>(() => store.state.keepAliveInclude)
    const keepAliveRoute = computed<string[]>(() => store.state.keepAliveRoute)

    onBeforeRouteLeave((to, from, next) => {
      if (to.name === 'Home') {
        store.commit('setKeepAliveInclude', keepAliveInclude.value.filter(ele => ele !== 'MyRecords'))
      } else {
        store.commit('setKeepAliveInclude', keepAliveRoute.value)
      }

      next()
    })

    return {
      getRecords,
      tabActive,
      tabList,
      addressInit,
      chainIdInit,
      redPackContractAddrInit,
      provider,
      phoneStyle,
      tokenInfoInit,
      receivedList,
      sentList,
      loading,
      getSent
    }
  }
})
